import {  Menu, MenuItem, Badge } from "@mui/material";
// import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import CustomTooltip from "../../Assets/customTheme/customtooltip"; // Make sure to import your custom tooltip
import { NotificationDarkIcon } from "../../Assets/svg/svgicon"; // Import your notification icon
import { Fade } from "@mui/material";
import { useNotification } from "./NotificationProvider";
import { MyNotificationsNoneRoundedIcon } from "../../Assets/svg/MyIcons";

const DropdownNotification = () => {
  const {
    notifications,
    loadMoreNotifications,
    handleNotificationClick,
    anchorElement,
    handleCloseNotification,
    displayedNotifications,
    unseenNotification,
  } = useNotification();

  const open = Boolean(anchorElement);
  const timeAgo = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays > 0) return `${diffInDays} days ago`;
    if (diffInHours > 0) return `${diffInHours} hours ago`;
    if (diffInMinutes > 0) return `${diffInMinutes} minutes ago`;
    return `${diffInSeconds} seconds ago`;
  };

  if ("Notification" in window) {
    if (Notification.permission !== "granted") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          // Notification permission granted
        }
      });
    }
  } else {
    console.warn("This browser does not support notifications.");
  }

  return (
    <div className="notification-box align-content-center">
      <CustomTooltip className="" title="Notification" placement="bottom" arrow>
        <Badge
          badgeContent={unseenNotification > 0 ? unseenNotification : "0"}
          sx={{
            "& .MuiBadge-badge": {
              background: "#dc2626",
              color: "#fff",
              top: "4px",
              right: "4px",
            },
          }}
        >
          <div
            className="btn btn-icon rounded-circle bg-white position-relative w-40px h-40px w-xl-50px h-xl-50px"
            id="kt_drawer_chat_toggle"
            onClick={handleNotificationClick}
            aria-controls={open ? "notification-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <span>
              <MyNotificationsNoneRoundedIcon className="fs-2qx text-primary" />
            </span>
          </div>
        </Badge>
      </CustomTooltip>
      <Menu
        anchorElement={anchorElement}
        id="notification-menu"
        open={open}
        onClose={handleCloseNotification}
        className="notification-menu custom-menu mt-13"
        disableEnforceFocus
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.20))",
            mt: 8.5,
            ml: -12,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "& .MuiList-root": {
              minWidth: "300px",
              maxWidth: "300px",

              minHeight: "350px",
              maxHeight: "350px",
              paddingTop: "0px",
              overflowY: "auto",
            },
            "& .MuiMenuItem-root": {
              whiteSpace: "break-spaces",
              padding: " 15px",
             
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            },
          },
        }}
        TransitionComponent={Fade}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
      >
        <div className="notification-header d-flex align-items-center justify-content-between flex-wrap bg-light-primary p-5">
          <h5 className="mb-0 ">Notifications</h5>
          <span>{unseenNotification} New</span>
        </div>
        {notifications?.length > 0 ? (
          <>
            <div className="notification-content">
              {displayedNotifications?.map((notif) => (
                <MenuItem key={notif.id} data-id={notif.id}>
                  <div
                    className="noti-text"
                    style={{
                      fontWeight: notif.isRead ? "normal" : "bold",
                    }}
                  >
                    {notif.message}
                  </div>
                  <span className="noti-time fs-9 text-gray-500 d-flex fw-semibold justify-content-end mt-3">
                    {timeAgo(notif.createdAt)}
                  </span>
                </MenuItem>
              ))}
            </div>
          </>
        ) : (
          <div
            className="notification-content"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              minHeight: "230px",
            }}
          >
            <NotificationDarkIcon width="80px" height="80px" />
            <p className="mt-5 fs-3">No Notifications</p>
          </div>
        )}
        {notifications?.length !== 0 &&
          notifications?.length !== displayedNotifications?.length && (
            <button
              className="btn btn-outline btn-outline-light-secondary btn-sm m-auto d-block"
              onClick={loadMoreNotifications}
            >
              Load More
            </button>
          )}
      </Menu>
    </div>
  );
};

export default DropdownNotification;
